// categoryMeta.js — ICONO por categoria del catalogo (+ re-export del color).
//
// Color: FUENTE UNICA en ui/theme/categoryColors (mismos hex que _color.scss).
// Se re-exporta aqui para los consumidores de SalasCmp y para que el color del
// tile, el del punto de la card y el de SceneCard (Itinerarios) COINCIDAN.
//
// Icono: se usa el asset generado (validado) si la categoria esta mapeada; si
// no, cae al `avatar` de BD. El texto NO va en el icono: lo pinta la app desde
// el nombre de la categoria.

import iconHumanas from "../../../assets/categorias/ciencias-humanas.png";
import iconNaturales from "../../../assets/categorias/ciencias-naturales.png";
import iconHistoria from "../../../assets/categorias/historia.png";
import iconMatematicas from "../../../assets/categorias/matematicas.png";
import iconArte from "../../../assets/categorias/arte.png";
import iconVida from "../../../assets/categorias/vida-saludable.png";
import {
  getCategoryColor,
  normalizeCategoryKey,
} from "../../../ui/theme/categoryColors";

// Re-export del color (fuente unica) para no romper imports existentes.
export { getCategoryColor, normalizeCategoryKey };

const CATEGORY_ICONS = {
  "CIENCIAS HUMANAS": iconHumanas,
  "CIENCIAS NATURALES": iconNaturales,
  HISTORIA: iconHistoria,
  MATEMATICAS: iconMatematicas,
  ARTE: iconArte,
  "VIDA SALUDABLE": iconVida,
};

// Icono de una categoria: usa el asset generado (validado) si la categoria esta
// mapeada; si no, cae al avatar de BD (para categorias sin icono propio).
export function getCategoryIcon(category) {
  const mapped =
    CATEGORY_ICONS[normalizeCategoryKey(category?.nameRaw || category?.name)];
  if (mapped) return mapped;
  return category?.avatar || null;
}

// Icono solo por nombre (para casos sin objeto categoria).
export function getCategoryIconByName(name) {
  return CATEGORY_ICONS[normalizeCategoryKey(name)] || null;
}
